(function() {
    'use strict';

    angular
        .module('madApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
